import MEACMembership from "../board-memberships/MEACMembership";
import EACEntries from "../docs-archive-elements/EACEntries";
export default function EACDetails() {
  return (
    <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Environmental Advisory Council (MEAC)</h2>
        </div>

        {/*End Large Image Space*/}

        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines">
            {/*Full Width Element*/}
            <div className="mb-960-col-50p left-side-col-50p">
              <h4>Meetings</h4>
              <ul>
                <li>7:00 p.m.</li>
                <li>2nd Thursday of the month</li>
                <li>
                  <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                    <i className="fa-solid fa-location-pin"></i>&nbsp;Borough Hall
                    <br />
                    35 Union Street
                    <br />
                    Morrisville, PA 19067
                  </a>
                  <br />
                </li>
                <li>
                  Entry to the building from the
                  <br />
                  Police parking lot entrance only
                </li>
              </ul>
              <h4>Composition</h4>
                <ul>
                  <li>5 Members</li>
                  <li>3 year terms</li>
                  <li>Terms expire on the 15th of December</li>
                </ul> 
              {/*Accordion Start*/}
              <div className="container accordion-container">
                <div className="accordion" id="councilMtgAccordion">
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEACpurpose">
                        <div>
                          <i className="fa-solid fa-scroll fa-2xl feature-icon af-icon"></i>
                        </div>
                        <div>
                          <b>Purpose</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseEACpurpose" className="accordion-collapse collapse" data-bs-parent="#EACAccordion">
                      <div className="accordion-body">
                        <p>
                          The Morrisville Environmental Advisory Council (MEAC) was created by Borough Council in 1998. The purpose of the MEAC is to advise elected officials, other local government
                          agencies, commissions and boards on matters dealing with the protection, conservation, management and use of natural resources, including air, land and water resources,
                          located within the Borough's boundaries. (Chapter 29, Borough Code). The MEAC has five members appointed by Borough Council and includes interested residents as Associate
                          Members. MEAC has a three (3) year term that expires the 3rd Monday in December.
                        </p>
                        <p>
                          The MEAC provides our local government with an accomplished blend of hometown knowledge, expertise, and genuine community concern on issues pertaining to the environment and
                          the quality of life in our community. Please join us as we help to make Morrisville a better place to live. Many associate members enjoy volunteering their knowledge and
                          skills on projects and issues that impact the environmental resources of Morrisville.
                        </p>
                        <p>The public is welcome at all meetings.</p>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEACprojects">
                        <div>
                          <i className="fa-solid fa-person-digging fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Ongoing Projects</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseEACprojects" className="accordion-collapse collapse" data-bs-parent="#EACAccordion">
                      <div className="accordion-body">
                        <h4>Ongoing Projects</h4>
                        <ul>
                          <li>
                            Morrisville Riverfront Preserve Restoration: The MEAC is working on behalf of the Borough in coordinating the ongoing restoration efforts at this 8.8 acre naturalized
                            riparian area. We have been successful in securing County and Federal grants, as well as donations, to fund the project. The MEAC has developed an informational brochure
                            describing the Preserve and its value as natural lands preservation. Volunteers for stewardship events are always needed. The Preserve is located at Delmorr and
                            Philadelphia Avenues.
                          </li>
                          <li>
                            Annual Graystone Woods Cleanup: Every Spring volunteers are organized to remove debris and selected invasive plants from this six-acre Woodland Forest. Graystone has
                            historical, geological, and ecological significance, and is preserved as a natural land preservation site. Graystone Woods is located on Crown Street.
                          </li>
                          <li>Annual Riverfront Cleanup: Each Spring, volunteers participate with the MEAC at the Morrisville Riverfront Preserve, located at Delmorr and Philadelphia Avenues.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                   {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBoardApply">
                        <div>
                          <i className="fa-solid fa-person-circle-plus fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Apply To Join The Board</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseBoardApply" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        Please send letters of interest to:<br/> <a href="mailto:office@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;office@morrisvilleboro.org
                  </a>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/*Accordion Finish*/}
            </div>

            <div className="mb-960-col-50p">
              <div className="council-members">
                <MEACMembership/>




<br/>
                <h4>Related Documents</h4>
                <EACEntries />
                
              </div>
            </div>
          </div>
        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
